export type ItemType = 'check' | 'photo_hint' | 'numeric';
export type RoleType = 'committee' | 'day' | 'night' | 'resident';

export interface ChecklistItem {
  id: string;
  text: string;
  type: ItemType;
  required: boolean;
  hint?: string;
}

export interface Checklist {
  id: string;
  title: string;
  role: RoleType | RoleType[];
  items: ChecklistItem[];
}

export interface UserSession {
  role: RoleType;
  name?: string;
  startTime: string; // ISO string
}

export interface InspectionRecord {
  itemId: string;
  status: 'ok' | 'fail' | 'na';
  value?: string | number;
  timestamp: string;
}

export const ROLE_LABELS: Record<RoleType, string> = {
  committee: '管委',
  day: '日班',
  night: '夜班',
  resident: '住戶',
};
